import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ComplementoWebState } from "./complemento-web.models";

export const selectSiniestrosState = createFeatureSelector<ComplementoWebState>('complementoWeb');

export const selectSiniestroSiniestros = createSelector(
    selectSiniestrosState,
    (state) => state.siniestro
);

export const selectDetalleSiniestroSiniestros = createSelector(
    selectSiniestrosState,
    (state) => state.detalleSiniestro
);

export const selectObjetoDetalleSiniestroSiniestros = createSelector(
    selectSiniestrosState,
    (state) => state.detalleSiniestro?.siniestroDetalle
);

export const selectListaCatalogosSiniestros = createSelector(
    selectSiniestrosState,
    (state) => state.catalogos
);

export const selectListaCatalogosTerceroSiniestros = createSelector(
    selectSiniestrosState,
    (state) => state.catalogosTercero
);